<script setup lang="ts">
import { getSeoObject } from "~/helpers/seo";

const { data } = useCustomFetch("/api/strapi/become-a-partner");

// useSeoMeta(getSeoObject(data.value?.seo));
</script>

<template>
  <section v-if="data" id="maincontentblock" class="aboutus partnersection">
    <SeoMeta v-if="data?.seo" v-bind="data?.seo" />
    <div
      class="blureffect goesleft"
      data-aos="fade-down"
      data-aos-easing="linear"
      data-aos-duration="1500"
    ></div>

    <div
      class="blureffect goesright"
      data-aos="fade-down"
      data-aos-easing="linear"
      data-aos-duration="1500"
    ></div>

    <div class="platformblock">
      <div class="container partners-container">
        <div class="row">
          <div class="col-md-7">
            <h2
              class="title"
              v-html="$mdRenderer.renderInline(data.heroTitle)"
            ></h2>
            <p
              class="titledesci"
              v-html="$mdRenderer.renderInline(data.heroDescription)"
            ></p>
            <div class="page-hdr-buttons">
              <NuxtLinkLocale
                v-for="button in data.heroButtons"
                :key="button.id"
                :to="button.url"
                :target="button.openInNewTab ? '_blank' : '_self'"
                class="buttons"
              >
                {{ button.name }}
              </NuxtLinkLocale>
            </div>
          </div>

          <div class="col-md-5">
            <img
              alt=""
              :src="$getStrapiImageSrc(data.heroImage)"
              class="img-fluid webtraderblockimg"
            />
          </div>
        </div>

        <div class="wrappers">
          <div class="my-animated-box animate-this">
            <div class="my-animated-box__children animate-this"></div>
          </div>

          <div class="my-animated-box animate-this downblock">
            <div class="my-animated-box__children animate-this"></div>
          </div>

          <div class="my-animated-box animate-this toobottom">
            <div class="my-animated-box__children animate-this"></div>
          </div>

          <div class="my-animated-box animate-this toobottomtoo">
            <div class="my-animated-box__children animate-this"></div>
          </div>

          <div class="wrapperblock whyblockin advantage partners-advantage">
            <div
              class="candle"
              data-aos="zoom-in-up"
              data-aos-delay="200"
            ></div>
            <div class="row">
              <h2
                class="ontitle"
                v-html="$mdRenderer.renderInline(data.advantagesTitle)"
              ></h2>
            </div>

            <div class="row">
              <div class="col-md-5">
                <img
                  alt=""
                  :src="$getStrapiImageSrc(data.advantagesImage)"
                  class="img-fluid"
                />
              </div>

              <div class="col-md-7 partners-col-md-7">
                <h3>
                  <strong>{{ data.advantagesInnerTitle }}</strong>
                </h3>

                <div v-html="$mdRenderer.render(data.advantagesText)"></div>
              </div>
            </div>

            <div class="row threeblocks modibox partners-modibox">
              <div
                v-for="(item, index) in data.advantagesItems"
                :key="item.id"
                class="col-md-3"
              >
                <div
                  class="glassblock"
                  data-aos="fade-up"
                  data-aos-anchor-placement="top-bottom"
                  :data-aos-delay="300 + index * 300"
                >
                  <img
                    alt=""
                    height="70"
                    :src="$getStrapiImageSrc(item.icon)"
                    class="icon"
                  />
                  <h2>{{ item.title }}</h2>
                  <p style="white-space: pre-line">{{ item.text }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ourcommitment partnerblock">
          <div class="row">
            <div class="col-md-12">
              <h2
                class="ontitle"
                v-html="$mdRenderer.renderInline(data.whyTitle)"
              ></h2>
              <p style="white-space: pre-line">{{ data.whyDescription }}</p>
            </div>
          </div>
          <div class="row">
            <div v-for="item in data.whyItems" :key="item.id" class="col-md-3">
              <div class="boxedcover">
                <img
                  alt=""
                  :src="$getStrapiImageSrc(item.icon)"
                  class="minico"
                />
                <h2>{{ item.title }}</h2>
                <p style="white-space: pre-line">{{ item.text }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section v-if="data" id="tradesmart" class="partnerstradesmart">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="wrappertrade partners-wrappertrade">
            <div
              class="blureffect right"
              data-aos="fade-down"
              data-aos-easing="linear"
              data-aos-duration="1500"
            ></div>

            <h2 style="white-space: pre-line">{{ data.joinTitle }}</h2>

            <img
              alt=""
              :src="$getStrapiImageSrc(data.joinImage)"
              data-aos="fade-zoom-in"
              data-aos-delay="300"
              class="mobiletrade"
            />

            <ul class="partners-ul">
              <li v-for="item in data.joinItems" :key="item.id">
                <strong>{{ item.title }}</strong>
                <span style="white-space: pre-line">
                  {{ item.text }}
                </span>
              </li>
            </ul>

            <NuxtLinkLocale
              :to="data.joinButtonLink"
              class="buttons partners-buttons"
            >
              {{ data.joinButtonText }}
            </NuxtLinkLocale>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section v-if="data" class="alertblockcall">
    <div class="container">
      <div
        class="blureffect ineffect"
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="1500"
      ></div>
      <div
        class="blureffect ineffectleft"
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="1500"
      ></div>
      <div class="row">
        <div class="col-md-12">
          <h2
            class="headline"
            v-html="$mdRenderer.renderInline(data.learnTitle)"
          ></h2>
          <p style="white-space: pre-line">
            {{ data.learnDescription }}
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="glassblock">
            <h3>{{ data.becomeTitle }}</h3>

            <NuxtLinkLocale
              v-for="button in data.becomeButtons"
              :key="button.id"
              :to="button.url"
              :target="button.openInNewTab ? '_blank' : '_self'"
              class="buttons"
            >
              {{ button.name }}
            </NuxtLinkLocale>
          </div>
        </div>
      </div>
    </div>
  </section>

  <JoinCta />

  <FaqItems :items="data?.faqs" />
</template>
